import { Dictionary } from '../../types/i18n';

export const ru: Dictionary = {
  meta: { locale: 'ru-RU' },
  nav: {
    stable: 'Конюшня',
    horses: 'Лошади',
    rides: 'Прогулки и цены',
    booking: 'Бронирование',
    events: 'Мероприятия',
    rules: 'Важно знать',
    book: 'Забронировать',
    menu: 'Меню',
  },
  hero: {
    location: '25 км от Таллина · 30 минут от аэропорта',
    title: 'Арабские лошади, сосновый лес и море',
    subtitle:
      'Конные прогулки с инструктором для любого уровня — от первой спокойной прогулки шагом до галопа вдоль берега Балтики. Небольшие группы, добрые лошади, время по световому дню.',
    cta: 'Забронировать прогулку',
    secondary: 'Познакомиться с лошадьми',
  },
  notice: {
    rides: 'Онлайн-бронирование прогулок — с 1 ноября 2026.',
    events: 'Свадьбы и фотосессии на сезон 2027 (с апреля) — забронируйте дату уже сейчас.',
    link: 'Оставить заявку',
  },
  gallery: {
    title: 'Конюшня',
    intro:
      'Деревянная конюшня на 16 денников и 16,5 гектара собственной земли — пастбища, лес рядом и деревенская тишина всего в 25 км от Таллина.',
    open: 'Открыть фото',
    more: '+{n} фото',
    close: 'Закрыть',
    prev: 'Предыдущее фото',
    next: 'Следующее фото',
  },
  horses: {
    title: 'Наши лошади',
    intro:
      'Все восемь наших лошадей — арабские, подготовленные для конных пробегов: выносливые, уверенные на любой тропе и добрые. Расскажите о своём опыте — подходящую лошадь подберём мы.',
    calm: 'Спокойные лошади',
    calmDesc: 'Для новичков и всадников среднего уровня. Шаг и лёгкая рысь.',
    advanced: 'Лошади для опытных всадников',
    advancedDesc: 'Для уверенных всадников, которые самостоятельно едут рысью и галопом.',
    age: '{n} лет',
  },
  routes: { forest: 'Лес', sea: 'Море' },
  rides: {
    title: 'Прогулки и цены',
    intro: 'Лес или море. Маршрут дня выбирает инструктор — в зависимости от погоды и состояния грунта.',
    forest: 'Лесные маршруты',
    forestDesc: 'Мягкие тропы под соснами и берёзами, защищённые от ветра — наш выбор в холодные и ветреные дни.',
    sea: 'Морские маршруты',
    seaDesc: 'Через дюны к широкому песчаному пляжу. Лучше всего в тихую погоду; опытные всадники могут скакать галопом вдоль воды.',
    colRide: 'Прогулка',
    colLevel: 'Уровень',
    colDuration: 'В седле',
    colPrice: 'Цена',
    perRider: 'за всадника',
    perGroup: 'за двоих',
    min: 'мин',
    book: 'Выбрать',
    prepNote:
      'Плюс 30 минут до прогулки (чистка и седловка вместе с вашей лошадью) и 30 минут после (расседлать и позаботиться о лошади). Входит в стоимость.',
    includedTitle: 'Что входит в каждую прогулку',
    included: [
      'Знакомство с лошадью и короткий инструктаж',
      'Чистка и седловка вместе с инструктором',
      'Шлем выдаём мы',
      'Короткая фотосессия верхом — по желанию',
      'Время с лошадьми после прогулки — почистить и угостить морковкой',
      'Чай и кофе в комнате отдыха',
    ],
    winterTitle: 'Зимняя цена',
    winterText: 'С ноября по март — скидка {amount} с каждого всадника на любую прогулку. Применяется автоматически при бронировании.',
    stebbyTitle: 'Оплата спорткомпенсацией',
    stebbyText: 'Прогулки можно оплатить спортивной компенсацией от работодателя через Stebby.',
    extrasTitle: 'Также',
    gift: 'Подарочный сертификат',
    giftDesc: 'Любая прогулка в подарок, действует 12 месяцев.',
    pack: 'Абонемент на 5 прогулок',
    packDesc: 'Скидка 10%, можно делить в семье.',
    private: 'Индивидуальная прогулка',
    privateDesc: 'Только вы и инструктор — +20 € к цене.',
  },
  booking: {
    title: 'Бронирование',
    intro: 'Выберите прогулку — календарь бронирования откроется прямо здесь, на странице. Выберите дату и время, примите условия и оплатите онлайн.',
    steps: [
      { title: 'Выберите прогулку', text: 'Каждая кнопка открывает календарь именно этой прогулки.' },
      { title: 'Выберите дату и время', text: 'Показываем только светлое время и дни со свободными лошадьми. Понедельник — выходной.' },
      { title: 'Подтвердите и оплатите', text: 'Примите условия и оплатите картой, Apple Pay или Google Pay. Подтверждение придёт на e-mail.' },
    ],
    chooseTitle: 'Выберите прогулку',
    book: 'Забронировать',
    allTimes: 'Ещё не решили? Все прогулки и время',
    assurances: [
      'Бесплатная отмена за 24 часа до прогулки',
      'Плохая погода — бесплатный перенос или полный возврат',
      'Зимняя цена с ноября по март',
      'Платите через Stebby? Напишите нам — пришлём ссылку.',
    ],
    agreeTitle: 'Перед бронированием',
    agreeIntro: 'Подтвердите за каждого всадника в бронировании:',
    requirements: 'Каждому всаднику не меньше 10 лет, вес до 95 кг.',
    agreeLiability:
      'Я понимаю, что верховая езда связана с риском, и катаюсь на свой риск. Конюшня не несёт ответственности за травмы и ущерб.',
    agreeInsurance: 'У каждого всадника в моём бронировании есть собственная страховка от несчастных случаев.',
    agreeCancel: 'Бесплатная отмена — не позднее чем за 24 часа. При более поздней отмене деньги не возвращаются.',
    mustAgree: 'Чтобы продолжить, примите все условия.',
    continue: 'Перейти к выбору даты и времени',
    modalTitle: 'Бронирование',
    loading: 'Загружаем календарь бронирования…',
    soonTitle: 'Онлайн-бронирование скоро откроется',
    soonText: 'А пока забронируйте по телефону или e-mail — отвечаем в тот же день.',
    call: 'Позвонить',
    write: 'Написать письмо',
    close: 'Закрыть',
  },
  events: {
    title: 'Свадьбы, фотосессии и праздники',
    intro:
      'С апреля по октябрь наши лошади, луга со стогами сена и лес станут вашими декорациями. Даты на сезон 2027 бронируются с 1 ноября — оставьте заявку сейчас, чтобы быть первыми.',
    from: 'от',
    season: 'Сезон: апрель – октябрь',
    request: 'Заявка на дату',
    name: 'Имя',
    email: 'E-mail',
    date: 'Желаемая дата',
    type: 'Повод',
    message: 'Расскажите о ваших планах',
    send: 'Отправить заявку',
    sent: 'Спасибо! Ответим в течение двух дней.',
    required: 'Заполните имя, e-mail и дату.',
  },
  rules: {
    title: 'Важно знать',
    intro: 'Прочитайте перед бронированием — оплачивая, вы принимаете эти условия.',
    items: [
      {
        title: 'Погода',
        text: 'Не выезжаем при температуре ниже −15 °C или выше +28 °C, в грозу, при ветре сильнее 15 м/с и на обледенелом грунте. Инструктор подтверждает прогулку до 9:00 в день выезда. Если отменяем мы — бесплатный перенос или полный возврат.',
      },
      {
        title: 'Световой день',
        text: 'Выезжаем только в светлое время. В декабре это примерно 10:00–15:00, летом — с 9:00 до 21:00. Календарь сам показывает доступное время.',
      },
      {
        title: 'Отмена',
        text: 'Бесплатно — не позднее чем за 24 часа до начала. Позже деньги не возвращаются, но можно передать место другому человеку.',
      },
      {
        title: 'Подготовка лошади',
        text: 'Приезжайте за 30 минут: вместе почистим лошадь и наденем амуницию. После прогулки ещё 30 минут — снять амуницию и позаботиться о лошади.',
      },
      {
        title: 'Ответственность и страховка',
        text: 'Верховая езда — занятие с повышенным риском. Бронируя, вы соглашаетесь, что катаетесь на свой риск и конюшня не несёт ответственности. Страховку от несчастных случаев каждый всадник оформляет сам.',
      },
      {
        title: 'Требования',
        text: 'Возраст от 10 лет (до 16 — с согласия родителя), вес до 95 кг. Шлем выдаём мы. Нужна закрытая обувь с небольшим каблуком и одежда по погоде.',
      },
    ],
  },
  footer: {
    tagline: 'Конные прогулки по лесу и у моря в Эстонии.',
    contact: 'Контакты',
    rights: 'Все права защищены.',
  },
};
